module.exports = __webpack_public_path__ + "img/travel_with_pet.e3417bfd.png";